export default "__VITE_ASSET__BYfh1CSz__"